import React from 'react'
import * as Badges from '../../../../../../components/badges'
import ExpandButton from '../expandButton'
import { FormatUtcDateAsLocal } from '../../../../../../helpers/datetime'
import AddDeleteTable from './addDeleteTable'
import UpdateTable from './updateTable'
import PropTypes from "prop-types"

class PoolShiftsUpdated extends React.Component {

  constructor(props) {
    super(props)
    this.state = { isExpanded: false }

    this.toggleExpand = this.toggleExpand.bind(this)
  }

  toggleExpand() {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }))
  }

  render() {
    let tables = []
    let payload = JSON.parse(this.props.item.payload)



    if (this.state.isExpanded) {
      if (payload.Added.length > 0) {
        tables.push(<React.Fragment key={'added'}><h4>Added</h4>
          <AddDeleteTable data={payload.Added} />
        </React.Fragment>)
      }
      if (payload.Updated.length > 0) {
        tables.push(<React.Fragment key={'updated'}><h4>Updated</h4>
          <UpdateTable data={payload.Updated} />
        </React.Fragment>)
      }

      if (payload.Deleted.length > 0) {
        tables.push(<React.Fragment key={'deleted'}>
          <h4>Deleted</h4>
          <AddDeleteTable data={payload.Deleted} />
        </React.Fragment>
        )
      }
    }

    let text = []
    let pluralShift = (count) => count === 1 ? 'shift' : 'shifts'
    if (payload.Added.length > 0) text.push(payload.Added.length + ' ' + pluralShift(payload.Added.length) + ' added')
    if (payload.Updated.length > 0) text.push(payload.Updated.length + ' ' + pluralShift(payload.Updated.length) + ' updated')
    if (payload.Deleted.length > 0) text.push(payload.Deleted.length + ' ' + pluralShift(payload.Deleted.length) + ' removed')

    return <tr>
      <td>
        <Badges.PoolShiftsUpdated /> <ExpandButton isExpanded={this.state.isExpanded} onClick={this.toggleExpand} />
      </td>
      <td>
        {!this.state.isExpanded && <span>{text.join(',')}</span>}
        {this.state.isExpanded && tables}</td>
      <td>{FormatUtcDateAsLocal(this.props.item.createdUtc)}</td>
      <td>{this.props.item.createdBy}</td>
    </tr>
  }
}

PoolShiftsUpdated.propTypes = {
  item: PropTypes.shape({
    payload: PropTypes.string.isRequired,
    createdUtc: PropTypes.string,
    createdBy: PropTypes.string
  }).isRequired
}

export default PoolShiftsUpdated



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/poolShiftsUpdated/index.js